import { COMPONENT_NAME_PREFIX } from '../constants';
import { PopupPlacement } from '../popup';
var elementName = COMPONENT_NAME_PREFIX + "toast";
var customCssPositionProperties = {
    TOP_MARGIN_TOP: '--tyl-toast-top-margin-top',
    BOTTOM_MARGIN_BOTTOM: '--tyl-toast-bottom-margin-bottom',
    TOP_LEFT_MARGIN_TOP: '--tyl-toast-top-left-margin-top',
    TOP_LEFT_MARGIN_LEFT: '--tyl-toast-top-left-margin-left',
    TOP_RIGHT_MARGIN_TOP: '--tyl-toast-top-right-margin-top',
    TOP_RIGHT_MARGIN_RIGHT: '--tyl-toast-top-right-margin-right',
    BOTTOM_LEFT_MARGIN_BOTTOM: '--tyl-toast-bottom-left-margin-bottom',
    BOTTOM_LEFT_MARGIN_LEFT: '--tyl-toast-bottom-left-margin-left',
    BOTTOM_RIGHT_MARGIN_RIGHT: '--tyl-toast-bottom-right-margin-right',
    BOTTOM_RIGHT_MARGIN_BOTTOM: '--tyl-toast-bottom-right-margin-bottom'
};
var classes = {
    CONTAINER: 'tyl-toast__container',
    MESSAGE: 'tyl-toast__message',
    ACTION_BUTTON: 'tyl-toast__action-button',
    CLOSE_BUTTON: 'tyl-toast__close-button',
    TOP: 'tyl-toast__container--top',
    TOP_LEFT: 'tyl-toast__container--top-left',
    TOP_RIGHT: 'tyl-toast__container--top-right',
    BOTTOM: 'tyl-toast__container--bottom',
    BOTTOM_LEFT: 'tyl-toast__container--bottom-left',
    BOTTOM_RIGHT: 'tyl-toast__container--bottom-right',
    ACTIVE: 'tyl-toast__container--active',
    CUSTOM: 'tyl-toast__container--custom'
};
var selectors = {
    CONTAINER: "." + classes.CONTAINER,
    MESSAGE: "." + classes.MESSAGE,
    ACTION_BUTTON: "." + classes.ACTION_BUTTON,
    CLOSE_BUTTON: "." + classes.CLOSE_BUTTON
};
var attributes = {
    MESSAGE: 'message',
    ACTION_TEXT: 'action-text',
    DURATION: 'duration',
    PLACEMENT: 'placement',
    SHOW_CLOSE: 'show-close'
};
var events = {
    ACTION: elementName + "-action",
    CLOSE: elementName + "-close"
};
var defaults = {
    PLACEMENT: PopupPlacement.Bottom,
    DURATION: 2750
};
export var TOAST_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    defaults: defaults,
    events: events,
    customCssPositionProperties: customCssPositionProperties
};
